/**
 * Recently viewed products are disabled. Keep the API without accessing storage.
 */
export class RecentlyViewed {
  /**
   * No-op retained for existing product-page callers.
   * @param {string} productId - Unused product ID.
   */
  static addProduct(productId) {}

  static clearProducts() {}

  /**
   * @returns {string[]} Always empty, so search skips recently viewed products.
   */
  static getProducts() {
    return [];
  }
}
